import { useEffect, useState } from 'react';
import { fetchPublicCourses } from './api/publicApi';

const ModuleIcon = () => (
  <svg width='11' height='15' viewBox='0 0 11 15' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path d='M7.875 7.37988V9.12988H2.625V7.37988H7.875ZM10.3086 3.25098C10.4362 3.37858 10.5 3.53353 10.5 3.71582V3.87988H7V0.379883H7.16406C7.34635 0.379883 7.5013 0.443685 7.62891 0.571289L10.3086 3.25098ZM6.125 4.09863C6.125 4.28092 6.1888 4.43587 6.31641 4.56348C6.44401 4.69108 6.59896 4.75488 6.78125 4.75488H10.5V13.7236C10.5 13.9059 10.4362 14.0609 10.3086 14.1885C10.181 14.3161 10.026 14.3799 9.84375 14.3799H0.65625C0.473958 14.3799 0.31901 14.3161 0.191406 14.1885C0.0638021 14.0609 0 13.9059 0 13.7236V1.03613C0 0.853841 0.0638021 0.698893 0.191406 0.571289C0.31901 0.443685 0.473958 0.379883 0.65625 0.379883H6.125V4.09863Z' fill='black' />
  </svg>
);

const ClockIcon = () => (
  <svg width='15' height='15' viewBox='0 0 15 15' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path d='M2.7373 2.59473C4.06803 1.264 5.6722 0.598633 7.5498 0.598633C9.42741 0.598633 11.0225 1.264 12.335 2.59473C13.6657 3.90723 14.3311 5.50228 14.3311 7.37988C14.3311 9.25749 13.6657 10.8617 12.335 12.1924C11.0225 13.5049 9.42741 14.1611 7.5498 14.1611C5.6722 14.1611 4.06803 13.5049 2.7373 12.1924C1.4248 10.8617 0.768555 9.25749 0.768555 7.37988C0.768555 5.50228 1.4248 3.90723 2.7373 2.59473ZM9.1084 10.1689C9.29069 10.2965 9.44564 10.2783 9.57324 10.1143L10.3389 9.04785C10.4665 8.86556 10.4482 8.71061 10.2842 8.58301L8.53418 7.3252V3.55176C8.53418 3.33301 8.4248 3.22363 8.20605 3.22363H6.89355C6.6748 3.22363 6.56543 3.33301 6.56543 3.55176V8.14551C6.56543 8.25488 6.611 8.34603 6.70215 8.41895L9.1084 10.1689Z' fill='black' />
  </svg>
);

const StudentIcon = () => (
  <svg width='14' height='15' viewBox='0 0 14 15' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path d='M9.37598 6.86816C8.7015 7.54264 7.88118 7.87988 6.91504 7.87988C5.94889 7.87988 5.11947 7.54264 4.42676 6.86816C3.75228 6.17546 3.41504 5.34603 3.41504 4.37988C3.41504 3.41374 3.75228 2.59342 4.42676 1.91895C5.11947 1.22624 5.94889 0.879883 6.91504 0.879883C7.88118 0.879883 8.7015 1.22624 9.37598 1.91895C10.0687 2.59342 10.415 3.41374 10.415 4.37988C10.415 5.34603 10.0687 6.17546 9.37598 6.86816ZM9.37598 8.75488C10.3786 8.75488 11.2354 9.11947 11.9463 9.84863C12.6755 10.5596 13.04 11.4163 13.04 12.4189V13.5674C13.04 13.932 12.9124 14.2419 12.6572 14.4971C12.402 14.7523 12.0921 14.8799 11.7275 14.8799H2.10254C1.73796 14.8799 1.42806 14.7523 1.17285 14.4971C0.917643 14.2419 0.790039 13.932 0.790039 13.5674V12.4189C0.790039 11.4163 1.14551 10.5596 1.85645 9.84863C2.58561 9.11947 3.4515 8.75488 4.4541 8.75488H4.91895C5.55697 9.04655 6.22233 9.19238 6.91504 9.19238C7.60775 9.19238 8.27311 9.04655 8.91113 8.75488H9.37598Z' fill='black' />
  </svg>
);

const FALLBACK_COURSES = [
  { id: 1, title: 'Introduction to the Digital Learning Platform', category: 'Introduction', modules_count: 6, duration_hours: '19h 30m', students_count: '20+', rating: 4.7, thumbnail_url: './Card 1.png' },
  { id: 2, title: 'Advocacy and Accountability', category: 'Health Science', modules_count: 4, duration_hours: '19h 30m', students_count: '20+', rating: 4.7, thumbnail_url: './Card 2.png' },
  { id: 3, title: 'Reproductive Health', category: 'Health Science', modules_count: 4, duration_hours: '19h 30m', students_count: '20+', rating: 4.7, thumbnail_url: './Card 3.png' },
];

const CourseCard = ({ course }) => (
  <div className='bg-white shadow-lg rounded-lg overflow-hidden hover:shadow-lg transition lg:w-[424px] lg:h-[488px] lg:mt-11 lg:ml-13 md:w-[340px] md:h-[420px] md:mt-8 sm:w-[444px] sm:h-[360px] sm:mt-6 sm:ml-4'>
    <div className='relative px-4 py-2'>
      <img
        src={course.thumbnail_url || './Card 1.png'}
        alt={course.title}
        className='object-cover lg:w-[384px] lg:h-[279px] md:w-[300px] md:h-[220px] sm:w-[390px] sm:h-[180px]'
      />
      <span className='absolute font-normal font-raleway rounded-md bg-red-500 text-white lg:top-8 lg:left-6 lg:text-sm lg:px-3 lg:py-1 md:top-6 md:left-4 md:text-xs md:px-2 md:py-1 sm:top-4 sm:left-3 sm:text-[10px] sm:px-2 sm:py-[2px]'>
        {course.category}
      </span>
    </div>
    <div className='p-3 space-y-4'>
      <div className='flex items-center space-x-2 text-xs'>
        <span>{'⭐'.repeat(Math.round(course.rating || 5))}</span>
        <span>({course.rating || '4.7'})</span>
      </div>
      <h3 className='font-semibold font-raleway text-orange-900 lg:text-base md:text-sm sm:text-xs'>
        {course.title}
      </h3>
      <div className='py-6'>
        <div className='flex justify-between font-raleway text-gray-600 lg:text-xs md:text-[11px] sm:text-[10px]'>
          <div className='flex items-center space-x-1 mt-2'>
            <ModuleIcon />
            <span>{course.modules_count} Modules</span>
          </div>
          <div className='flex items-center space-x-1'>
            <ClockIcon />
            <span>{course.duration_hours}</span>
          </div>
          <div className='flex items-center space-x-1'>
            <StudentIcon />
            <span>Students {course.students_count}</span>
          </div>
        </div>
        <div className='text-gray-600 text-sm font-raleway py-3'>
          <span>-------------------------------------------------------------------</span>
        </div>
      </div>
    </div>
  </div>
);

const Section3 = () => {
  const [courses, setCourses] = useState(FALLBACK_COURSES);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const controller = new AbortController();
    fetchPublicCourses(controller.signal)
      .then((result) => {
        const data = Array.isArray(result?.data) ? result.data : [];
        if (data.length > 0) setCourses(data);
      })
      .catch(() => {})
      .finally(() => setLoading(false));
    return () => controller.abort();
  }, []);

  return (
    <section
      className='  bg-cover bg-center h-full w-full space-y-4 py-16 px-6 md:px-20 mt-12 bg-red-500 shadow-3xl'
      style={{ backgroundImage: "url('./Backky.jpg')" }}
    >
      {/* Up part Section */}
      {/* Up part Section */}
      <div className='flex flex-col lg:flex-row items-start justify-between lg:items-center mb-10'>
        {/* Left Side */}
        <div className='text-center lg:text-left space-y-5'>
          {/* Badge */}
          <div className='flex items-center space-x-2 text-left mb-1'>
            <img
              src='./sphere.png'
              alt='About Us'
              className='
          lg:h-[17px] lg:w-[23px]
          md:h-[15px] md:w-[20px]
          sm:h-[13px] sm:w-[18px]
        '
            />
            <p className='text-xs md:text-sm lg:text-xs text-orange-400 font-raleway'>
              Top Popular Course
            </p>
          </div>

          {/* Heading */}
          <div>
            <h2
              className='
          font-Anton text-orange-900
          lg:text-4xl md:text-3xl sm:text-2xl
        '
            >
              Check Out Our EnRich <br /> Accredited Courses
            </h2>
          </div>
        </div>

        {/* Right Side - Button */}
        <div className='flex items-center mt-4 lg:mt-0'>
          <button
            className='
        bg-orange-500 hover:bg-orange-600 font-raleway text-white rounded-md flex items-center space-x-2
        lg:text-sm lg:px-7 lg:py-3
        md:text-xs md:px-6 md:py-2
        sm:text-xs sm:px-5 sm:py-2
      '
          >
            Browse care Courses
            <svg
              width='20'
              height='21'
              viewBox='0 0 20 21'
              fill='none'
              xmlns='http://www.w3.org/2000/svg'
              className='lg:w-5 lg:h-5 md:w-4 md:h-4 sm:w-3 sm:h-3'
            >
              <path
                d='M6.99961 1.19995L5.59961 2.69995L12.9996 10.2L5.59961 17.7L6.99961 19.2L15.9996 10.2L6.99961 1.19995Z'
                fill='#FDF1E9'
              />
            </svg>
          </button>
        </div>
      </div>

      {/* Grid of Cards */}
      {loading ? (
        <div className='grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8'>
          {[1, 2, 3].map((n) => (
            <div key={n} className='bg-white shadow-lg rounded-lg overflow-hidden animate-pulse lg:w-[424px] lg:h-[488px] lg:mt-11'>
              <div className='bg-gray-200 lg:w-full lg:h-[279px] md:h-[220px] h-[180px]' />
              <div className='p-4 space-y-3'>
                <div className='h-3 bg-gray-200 rounded w-1/3' />
                <div className='h-4 bg-gray-200 rounded w-3/4' />
                <div className='h-3 bg-gray-200 rounded w-full' />
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className='grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8'>
          {courses.slice(0, 3).map((course) => (
            <CourseCard key={course.id} course={course} />
          ))}
        </div>
      )}
    </section>
  );
};

export default Section3;
